export default {"src":"/_next/static/media/hockey.e8968c55.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};